import Tableau from "./Tableau";
export default Tableau;
